export const label = 'I’d like to receive SMS texts for relevant order status updates.';
export const labelCheckoutOptimisation = 'Text me with order updates';
